import React, { useState, useEffect, useCallback, useRef } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { handleAddLogic } from "../utils/searchHelpers";
import "../styles/search.css";
import phone from "../assets/phone.png";

const Search = () => {
  const [commMethod, setCommMethod] = useState("email");
  const [searchQuery, setSearchQuery] = useState("");
  const [crn, setCRN] = useState("");
  const [errors, setErrors] = useState({ searchQuery: "", crn: "" });
  const [isFormValid, setIsFormValid] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [validStatus, setValidStatus] = useState({
    searchQuery: false,
    crn: false,
  });
  const phoneRef = useRef(null);

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  const validatePhoneNumber = (number) => {
    const re = /^\d{10}$/; // Assumes 10-digit phone numbers
    return re.test(String(number));
  };

  const validateCRN = (crn) => {
    const re = /^\d{5}$/;
    return re.test(String(crn));
  };

  const validateInputs = useCallback(() => {
    let valid = true;
    const newErrors = { searchQuery: "", crn: "" };
    const newValidStatus = { searchQuery: false, crn: false };

    if (commMethod === "email") {
      if (!validateEmail(searchQuery)) {
        newErrors.searchQuery = "Invalid email format";
        valid = false;
      } else {
        newValidStatus.searchQuery = true;
      }
    } else if (commMethod === "text") {
      if (!validatePhoneNumber(searchQuery)) {
        newErrors.searchQuery = "Invalid phone number format";
        valid = false;
      } else {
        newValidStatus.searchQuery = true;
      }
    }

    if (!validateCRN(crn)) {
      newErrors.crn = "CRN must be exactly 5 digits";
      valid = false;
    } else {
      newValidStatus.crn = true;
    }

    setErrors(newErrors);
    setValidStatus(newValidStatus);
    setIsFormValid(valid);
    return valid;
  }, [commMethod, searchQuery, crn]);

  useEffect(() => {
    validateInputs();
  }, [searchQuery, crn, commMethod, validateInputs]);

  const handleAdd = async (e) => {
    e.preventDefault();
    if (validateInputs()) {
      setIsSubmitting(true);
      await handleAddLogic(commMethod, searchQuery, crn);
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (phoneRef.current) {
      //add the phone-search class to the phone image
      setTimeout(() => {
        phoneRef.current.classList.add("phone-search");
      }, 1);
    }
  }, []);

  return (
    <div className="search">
      <Header />
      <div className="search-body">
        <form onSubmit={handleAdd} className="search-form">
          <div className="button-group">
            <div className="toggle-switch">
              <input
                type="radio"
                id="email"
                name="commMethod"
                checked={commMethod === "email"}
                onChange={() => setCommMethod("email")}
                className="toggle-switch-input"
              />
              <label htmlFor="email" className="toggle-switch-label">
                Email
              </label>
              <input
                type="radio"
                id="text"
                name="commMethod"
                checked={commMethod === "text"}
                onChange={() => setCommMethod("text")}
                className="toggle-switch-input"
              />
              <label htmlFor="text" className="toggle-switch-label">
                Phone
              </label>
            </div>
          </div>
          <div className="input-group">
            <label htmlFor="searchQuery" className="input-label">
              {commMethod === "email" ? "Email" : "Phone Number"}
            </label>
            <input
              type={commMethod === "email" ? "email" : "tel"}
              id="searchQuery"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder={`Enter your ${commMethod}`}
              className={`search-input ${
                errors.searchQuery
                  ? "invalid"
                  : validStatus.searchQuery
                  ? "valid"
                  : ""
              }`}
            />
            <div className="error-message">{errors.searchQuery}</div>
          </div>
          <div className="input-group">
            <label htmlFor="crn" className="input-label">
              Course Number (CRN)
            </label>
            <input
              type="text"
              id="crn"
              value={crn}
              onChange={(e) => setCRN(e.target.value)}
              maxLength="5"
              placeholder="Enter CRN (5 digits)"
              className={`search-input ${
                errors.crn ? "invalid" : validStatus.crn ? "valid" : ""
              }`}
            />
            <div className="error-message">{errors.crn}</div>
          </div>
          <button
            type="submit"
            className="search-submit primary-button"
            disabled={!isFormValid || isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </button>
        </form>
        <div className="search-assets">
          <img src={phone} alt="Phone" className="phone" ref={phoneRef} />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Search;
